jQuery(function ($) {
    $(document).ready(function () {
        function initNavTabs() {
            if ($('.clean-beauty-nav-tabs').length > 0) {
                $('.tab-nav').on('click', function () {
                    const currentTab = $('.tab-nav.active').data('target');
                    const targetTab = $(this).data('target');

                    $('.tab-nav.active').removeClass('active text-verdilabblack underline underline-offset-4');
                    $(this).addClass('active text-verdilabblack underline underline-offset-4');

                    $(`.${currentTab}`).addClass('opacity-0');
                    $(`.${currentTab}-img`).addClass('opacity-0');

                    setTimeout(function () {
                        $(`.${currentTab}`).addClass('hidden');
                        $(`.${currentTab}-img`).addClass('hidden');

                        $(`.${targetTab}`).removeClass('hidden');
                        $(`.${targetTab}-img`).removeClass('hidden');

                        setTimeout(function () {
                            $(`.${targetTab}`).removeClass('opacity-0');
                            $(`.${targetTab}-img`).removeClass('opacity-0');
                        }, 150);
                    }, 300);
                });
            }
        }

        function initTooltips() {
            if ($('.clean-beauty-tooltip').length > 0) {
                $(".clean-beauty-tooltip").on({
                    mouseenter: function () {
                        $(this).children(":first").show();
                    },
                    mouseleave: function () {
                        $(this).children(":first").hide();
                    },
                    click: function () {
                        $(this).children(":first").show();
                    }
                });
            }
        }

        function initModalActions() {
            $("a[href*='#blacklist-modal']").removeAttr('data-uk-modal');
            $("a[href*='#blacklist-modal']").addClass('blacklist-modal-open');
            $("a[href*='#blacklist-modal']").removeAttr('href');

            $('.blacklist-modal-open').on('click', function() {
                $('#blacklist-modal').removeClass('-translate-y-[101%] opacity-0 -top-full').addClass('top-0');
                $('.blacklist-modal-close').addClass('fixed');
                $('html').css('overflow-y', 'hidden');

                $('#blacklist-modal').on('click', '.blacklist-modal-close', function() {
                    $('#blacklist-modal').addClass('-translate-y-[101%] opacity-0 -top-full').removeClass('top-0');
                    $('.blacklist-modal-close').removeClass('fixed');
                    $('html').css('overflow-y', '');
                });
            });
        }

        initNavTabs();
        initTooltips();
        initModalActions();
    });
});
